import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const ORDER_SIBLINGS_SUCCESS = "ORDER_SIBLINGS_SUCCESS";
export const ORDER_SIBLINGS_ERROR = "ORDER_SIBLINGS_ERROR";

// Thunk Action Creator
export const orderSiblingsInTodo = createAsyncThunk(
    "api/Task/orderSiblings",
    async (json, { dispatch }) => {

        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/orderSiblings/${json.id}`,
                    {
                        id: json.id,
                        Ids: json.Ids
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );


                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }                }
                else {
                    throw new Error("Error ordering siblings");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: ORDER_SIBLINGS_SUCCESS,
                    payload: response.data
                });

            } else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: ORDER_SIBLINGS_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
            //.then(response => {
            //    dispatch({
            //        type: ORDER_SIBLINGS_SUCCESS,
            //        payload: response.data,
            //    });
            //    dispatch(getLatestTaskList());
            //})
            //.catch(error => {
            //    dispatch({ type: ORDER_SIBLINGS_ERROR, payload: error });
            //});
        } catch (error) {
            dispatch({ type: ORDER_SIBLINGS_ERROR, payload: error });
            await signOut();
        }
    }
);
